import { Row } from 'react-bootstrap';
import '../styles/components/info-modal-section.scss';

const MortgageReportDescription = () => {
  return (
    <>
      <Row className="section">
        <h2>Help</h2>
        <p className="text-start">
          Please click on &#39;Download&#39; to save a copy of the report to your computer.
        </p>
      </Row>
    </>
  );
};

export default MortgageReportDescription;
